import { useState, useEffect } from 'react';
import Link from '@/components/utilities/SmartLink';
import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const FeaturesSmallCardsContainer = ({ smallCards, labelShowMore }) => {
  const [showMore, setShowMore] = useState(true);

  useEffect(() => {
    // Detekce mobilního zařízení podle velikosti obrazovky
    setTimeout(() => {
      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      setShowMore(!isMobile);
    }, 0);
  }, []);

  const visibleCards = !showMore ? (smallCards || []).slice(0, 5) : smallCards;

  return (
    <div className="mx-auto mt-6 mb-6 w-[90vw] lg:mt-32 xl:w-(--container-width)">
      <div className="-mx-2 flex flex-wrap gap-y-2 xl:gap-y-6">
        {(visibleCards || []).map((card, index) => (
          <VisibleLoading key={card.id} delay={((index % 3) + 1) * 100}>
            {({ ref, className }) => <FeaturesSmallCard innerRef={ref} className={className} card={card} />}
          </VisibleLoading>
        ))}
      </div>

      {!showMore && (smallCards || []).length > 5 && (
        <VisibleLoading delay={400}>
          {({ ref, className }) => (
            <div ref={ref} className={className}>
              <div
                onClick={() => setShowMore(true)}
                className="mt-6 flex cursor-pointer justify-center text-white/80 underline underline-offset-4 transition-colors hover:text-white"
              >
                {labelShowMore} {smallCards.length - 5}
              </div>
            </div>
          )}
        </VisibleLoading>
      )}
    </div>
  );
};
export default FeaturesSmallCardsContainer;

export const FeaturesSmallCard = ({ innerRef, className, card }) => {
  return (
    <div
      ref={innerRef}
      className={`group relative w-full cursor-pointer px-2 lg:basis-1/3 ${className || ''} ${!card.link ? 'pointer-events-none' : ''}`.trim()}
    >
      <Link href={card.link || '/'}>
        <div className="rounded-xl bg-gradient-to-r from-[var(--color-white-20)] to-[var(--color-white-20)] p-[1px] transition-colors duration-500 group-hover:bg-gradient-to-r group-hover:from-[var(--color-white-20)] group-hover:to-[var(--color-brand-400)]">
          <div className="flex min-h-18 items-center gap-3 rounded-xl bg-[#171717] px-4 py-3">
            <div className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-linear-[45deg,transparent_10%,var(--color-white-50)]">
              <div className="flex h-[37px] w-[37px] items-center justify-center rounded-full bg-[#171717]">
                <Icon type={card.icon} width={20} height={20} />
              </div>
            </div>
            <div className="txt-xl flex-1">{card.text}</div>
            <div className="transition-transform duration-500 group-hover:translate-x-1">
              {!card.link ? null : <Icon type="chevronRight" color="var(--color-brand-400)" width={24} height={24} />}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};
